/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/horse_exam_requirement_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./horse_exam_requirement_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.HorseExamRequirementServiceClient =
  function HorseExamRequirementServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.HorseExamRequirementServicePromiseClient =
  function HorseExamRequirementServicePromiseClient(
    hostname,
    credentials,
    options
  ) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse>}
 */
const methodDescriptor_HorseExamRequirementService_ListHorseExamRequirements =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamRequirementService/ListHorseExamRequirements",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListHorseExamRequirementsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListHorseExamRequirementsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListHorseExamRequirementsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseExamRequirementServiceClient.prototype.listHorseExamRequirements =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamRequirementService/ListHorseExamRequirements",
      request,
      metadata || {},
      methodDescriptor_HorseExamRequirementService_ListHorseExamRequirements,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseExamRequirementServicePromiseClient.prototype.listHorseExamRequirements =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamRequirementService/ListHorseExamRequirements",
      request,
      metadata || {},
      methodDescriptor_HorseExamRequirementService_ListHorseExamRequirements
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest,
 *   !proto.stronachgroup.first.racehorse360.HorseExamRequirement>}
 */
const methodDescriptor_HorseExamRequirementService_ConfirmExamRequirementReadiness =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamRequirementService/ConfirmExamRequirementReadiness",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ConfirmExamRequirementReadinessRequest,
    stronachgroup_first_racehorse360_messages_pb.HorseExamRequirement,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.HorseExamRequirement.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.HorseExamRequirement)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.HorseExamRequirement>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseExamRequirementServiceClient.prototype.confirmExamRequirementReadiness =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamRequirementService/ConfirmExamRequirementReadiness",
      request,
      metadata || {},
      methodDescriptor_HorseExamRequirementService_ConfirmExamRequirementReadiness,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.HorseExamRequirement>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseExamRequirementServicePromiseClient.prototype.confirmExamRequirementReadiness =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamRequirementService/ConfirmExamRequirementReadiness",
      request,
      metadata || {},
      methodDescriptor_HorseExamRequirementService_ConfirmExamRequirementReadiness
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
